import React, { useCallback, useEffect, useState } from 'react'
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import "./ViewAllCommon.scss"
import { useHistory } from "react-router"
import ApprovalRequest from 'pages/ApprovalRequest'
import PendingDiscountList from './PendingDiscountList'
import PendingRaiseRequests from 'pages/PendingRaiseRequests/PendingRaiseRequests'
import { useSelector } from "react-redux"
import { MocUserRole } from 'core/services/models/Enums'
import PendingChemoApproval from './PendingChemoApproval'
import { useLocation } from "react-router-dom"
import { getAllStaffs } from 'core/services/api'


function ViewAllCommon() {
  interface TabPanelProps {
    children?: React.ReactNode
    index: number
    value: number
  }
  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    )
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    }
  }
  const location = useLocation()
  const [displayToast, toggleToast] = useState<any>(false)
  const tabValueReturned = location?.state?.tabValue
  const [value, setValue] = React.useState(tabValueReturned ? tabValueReturned : 0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }
  const history = useHistory()
  const userRole = useSelector((state: any) => state?.user?.role)
  const userDetail = useSelector((state: any) => state?.user?.userDetail);
  const [consultantDetailsResult, setConsultantDetailsResult] = useState<
    string[]
  >([])

  // const OptimizedApprovalRequest = useCallback<any>(()=>ApprovalRequest, [])
  useEffect(() => {
    // fetchPatientDetails()
    fetchConsultantDetails()
  }, [])

  function fetchConsultantDetails() {
    getAllStaffs(
      `?primaryRole=CONSULTANT&centerId=${userDetail?.currentCenter?.centerId}`
    ).then((res: any) => {
      setConsultantDetailsResult(res)
    })
  }

  return (
    <>
      <div style={{ display: 'flex' }}>
        <div
          className="approval-back-image"
          onClick={() => {
            history.push("/")
          }}
        >
          <img
            src="../../assets/images/back-icon.svg"
            height={"60px"}
            width={"60px"}
            alt="back button"
            className="back_button"

          />
        </div>
        <div className='pending-request-heading'>Pending Requests</div>
      </div>

      {
        userRole == MocUserRole?.RMO ? <>
          <Box sx={{ width: "100%", marginTop: "20px" }}>
            <Box sx={{}}>
              <Tabs
                TabIndicatorProps={{
                  sx: {
                    bgcolor: "blue",
                    height: "2px",
                    color: "blue",
                  },
                }}
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >

                <Tab
                  sx={{
                    textTransform: "none",
                    fontSize: "20px",
                    fontWeight: "700",
                  }}
                  label="Clinical Request"
                  {...a11yProps(0)}
                />


                <Tab
                  sx={{
                    textTransform: "none",
                    fontSize: "20px",
                    fontWeight: "700",
                  }}
                  label="Chemo Approval Request"
                  {...a11yProps(1)}
                />

              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <ApprovalRequest
                displayToast={displayToast}
                toggleToast={toggleToast}
                consultantDetailsResult={consultantDetailsResult}
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <PendingChemoApproval />
            </TabPanel>
          </Box>
        </>
          :
          userRole == MocUserRole?.CENTER_ADMIN ? <>
            <PendingDiscountList />
          </>
            : userRole === MocUserRole?.MRD ? <>
              <PendingRaiseRequests />
            </>
              :
              <>
                <Box sx={{ width: "100%", marginTop: "20px" }}>
                  <Box sx={{}}>
                    <Tabs
                      TabIndicatorProps={{
                        sx: {
                          bgcolor: "blue",
                          height: "2px",
                          color: "blue",
                        },
                      }}
                      value={value}
                      onChange={handleChange}
                      aria-label="basic tabs example"
                    >

                      <Tab
                        sx={{
                          textTransform: "none",
                          fontSize: "20px",
                          fontWeight: "700",
                        }}
                        label="Clinical Request"
                        {...a11yProps(0)}
                      />


                      <Tab
                        sx={{
                          textTransform: "none",
                          fontSize: "20px",
                          fontWeight: "700",
                        }}
                        label="Billing Request"
                        {...a11yProps(1)}
                      />

                      <Tab
                        sx={{
                          textTransform: "none",
                          fontSize: "20px",
                          fontWeight: "700",
                        }}
                        label="Chemo Approval Request"
                        {...a11yProps(2)}
                      />

                    </Tabs>
                  </Box>
                  <TabPanel value={value} index={0}>
                    <ApprovalRequest
                      displayToast={displayToast}
                      toggleToast={toggleToast}
                      consultantDetailsResult={consultantDetailsResult}
                    />
                      
                  </TabPanel>
                  <TabPanel value={value} index={1}>
                    <PendingDiscountList />
                  </TabPanel>
                  <TabPanel value={value} index={2}>
                    <PendingChemoApproval />
                  </TabPanel>
                </Box>
              </>}
    </>

  )
}

export default ViewAllCommon